import Link from 'next/link'

import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MedicalDisclaimerProps {
    className?: string
}

// Required at the end of every article and pillar page.
export const MedicalDisclaimer: FC<MedicalDisclaimerProps> = ({ className }): ReactNode => {
    return (
        <p
            className={cn(
                'rounded-2xl border border-border bg-secondary/30 px-5 py-4 text-sm leading-relaxed text-muted-foreground',
                className
            )}
        >
            Editorial content for general information only, not a substitute for professional
            medical advice. Read more about{' '}
            <Link href='/about' className='font-medium text-foreground underline underline-offset-2'>
                how we source and review our content
            </Link>
            .
        </p>
    )
}
